// FormFieldPrivacy
//
// Shared field-level privacy rules for Snowplow form tracking - both native
// (@snowplow/browser-plugin-form-tracking) and virtual (./virtual-form-tracking)
// use these same two functions as their `fields.filter`/`fields.transform`
// (native) or `filter`/`transform` (virtual) options, so a field is judged
// safe to send - and obscured the same way - no matter which of the two
// tracking paths actually captured it.

import CryptoJS from 'crypto-js';

// Blocks a field from being tracked at all - checked before transform ever
// runs, so a blocked field is omitted entirely rather than sent hashed.
export function isFieldAllowed(elt) {
  const type = (elt.type || '').toLowerCase();
  const autocomplete = (elt.autocomplete || '').toLowerCase();
  const name = (elt.name || '').toLowerCase();
  const id = (elt.id || '').toLowerCase();
  const placeholder = (elt.placeholder || '').toLowerCase();
  // get label text if available
  let label = '';
  if (elt.labels && elt.labels.length > 0) {
    label = elt.labels[0].innerText.toLowerCase();
  }
  const fieldIdentifier = `${name} ${id} ${placeholder} ${label}`;

  // BLOCK by TYPE
  if (type === 'password' || type === 'hidden' || type === 'number' || type === 'tel') {
    return false;
  }
  // BLOCK by AUTOCOMPLETE
  if (autocomplete.includes('cc') || autocomplete.includes('card') || autocomplete.includes('credit') || autocomplete.includes('debit') ||
      autocomplete.includes('one-time-code') || autocomplete.includes('otp') || autocomplete.includes('bday') || autocomplete.includes('bank') || autocomplete.includes('account')) {
    return false;
  }
  // BLOCK by KEYWORDS
  const sensitiveKeywords = [
    'password', 'otp', 'verification', 'cvv', 'cvc', 'card', 'credit', 'debit', 'expiry',
    'bank', 'account', 'ifsc', 'swift', 'aadhaar'
  ];
  if (sensitiveKeywords.some(k => fieldIdentifier.includes(k))) {
    return false;
  }
  if (elt.name === "private") {
    return false;
  }
  return true;
}

// Obscures an allowed field's value before it's sent - matches the
// (value, elt, el) transform signature both tracking paths call it with.
export function FormFieldEncryption(value, _, elt) {
  const hashFormData = CryptoJS.enc.Utf8.parse(value);
  return CryptoJS.enc.Base64.stringify(hashFormData);
}
